/* @flow */
import React from 'react';

import THead from 'components/UIKit/Table/THead';
import Tr from 'components/UIKit/Table/Tr';
import Th from 'components/UIKit/Table/Th';

export default function DynamicEntityColumns({
  sort, order
}: any): React.Element {
  return (
    <THead>
      <Tr>
        <Th sort={sort} order={order} sortable field="submitter_id" style={{paddingLeft: '2.8rem'}}>Submitter ID</Th>
        <Th>Type</Th>
        <Th>Case ID</Th>
        <Th>State</Th>
        <Th sort={sort} order={order} sortable field="updated_datetime">Last Updated</Th>
      </Tr>
    </THead>
  );
}
